module.exports = {"components.auth.authFooter.linkText.learnMore":"Erfahren Sie mehr","components.auth.authFooter.linkText.privacy":"Datenschutz","components.auth.authFooter.link.privacy":"https://choosemuse.com/de/legal/#DieDatenschutzrichtlinieVonInteraxon","components.auth.authFooter.linkText.contactUs":"Kontaktieren Sie uns"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de/components/Auth/AuthFooter/AuthFooter.json
// module id = 864
// module chunks = 0